class HeaderSearch extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.controller = null;
    this.cachedResults = {};
    this.isMobile = window.innerWidth < 1025 ? true : false;

    this.buildSelectors();
    this.buildProductObject();
    if (!this.isMobile) this.setModalPosition();
    this.setupEventListeners();
    this.initialRender(false);
  }

  buildSelectors() {
    this.model = this.querySelector('[data-ajax-search-results]');
    this.input = this.querySelector('input[data-header-search]');
    this.form = this.input.closest('form');
    this.formResetBtn = this.form.querySelector('[type="reset"]');
    this.predictiveSearchResults = this.querySelector('[data-search-products]');
    this.predictiveSearchViewAllBtns = this.querySelectorAll('[data-search-view-all]');
    this.overlay = document.querySelector('.wrapper-overlay');
    this.closeSearchBtns = this.querySelectorAll('[data-close-search]');

    this.trendingSearcheList = this.querySelectorAll('[data-list-trending-searches]');
    this.brandsList = this.querySelectorAll('[data-list-brands]');
    this.suggestionList = this.querySelectorAll('[data-list-suggestions]');
    this.pagesList = this.querySelectorAll('[data-list-pages]');

    this.noResultTextNodes = this.querySelectorAll('[data-noresult-block] span');
    this.searchIcon = document.querySelector('.site-header .head-search input[name="head-search"]');
    this.statusElement = this.statusElement || this.form.querySelector('.predictive-search-status');
  }
  buildProductObject() {
    const defaultConfig = window._theme.headerSearch || null;
    if (!defaultConfig) return;

    this.defaultConfig = defaultConfig;
    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts || [];
    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.map((product) => {
      const product_url = `/products/${product.handle}`;
      const variants = product.variants.map((variant, index) => {
        // Ensure metafield data is properly structured
        const metafieldValue =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.brightperl_variant_inventory
            ? variant.metafields.custom.brightperl_variant_inventory
            : '';

        const expressShippingAllow =
          variant.metafields &&
          variant.metafields.custom &&
          variant.metafields.custom.allow_express_shipping
            ? variant.metafields.custom.allow_express_shipping
            : '';

        return {
          ...variant,
          available: variant.available ? '1' : '0',
          image_alt: variant.featured_image ? variant.featured_image.alt : '',
          image_link: variant.featured_image ? variant.featured_image.src : '',
          link: `${product_url}?variant=${variant.id}`,
          list_price: variant.compare_at_price ? variant.compare_at_price / 100 : null,
          price: variant.price / 100,
          quantity_total: variant.inventory_quantity || 0,
          sku: variant.sku || '',
          taxable: variant.taxable ? '1' : '0',
          variant_id: variant.id,
          search_variant_metafields_data: {
            variant_metafield_69f1d8722b9c470908fa53fe850945fb: metafieldValue,
            variant_metafield_070071a13a8ea5aafeb0b99afa0c101f: expressShippingAllow,
          },
        };
      });

      return {
        ...product,
        metafield_68be2c8c872cca8e6b86ad08cbae727c: product.review_summary_metadata || '',
        product_id: product.id,
        link: `/products/${product.handle}`,
        image_link: product.featured_image,
        shopify_images: product.images || [],
        tags: product.tags.join('[:ATTR:]'),
        list_price: product.compare_at_price / 100,
        price: product.price / 100,
        shopify_variants: variants,
      };
    });

    this.defaultConfig.defaultProducts = this.defaultConfig.defaultProducts.filter(
      (p) => p.available
    );

    delete window._theme.headerSearch;
  }

  setModalPosition() {
    this.isMobile = window.innerWidth < 1025 ? true : false;
    const modelData = this.getResultsMaxHeight();

    if (this.isMobile) {
      this.model.style.setProperty('--modelTopPos', modelData.announcementBottom + 'px');
      this.model.style.setProperty('--modelMaxHeight', '100vh');
      this.predictiveSearchResults.style.setProperty('--productContainerMaxHeight', '100%');
    } else {
      const productContainerMaxHeight = window.innerHeight - modelData.modelTopPos - 140;
      this.model.style.setProperty('--modelTopPos', modelData.modelTopPos + 'px');
      this.model.style.setProperty('--modelMaxHeight', modelData.modelMaxHeight + 'px');
      this.predictiveSearchResults.style.setProperty(
        '--productContainerMaxHeight',
        productContainerMaxHeight + 'px'
      );
    }
  }
  setupEventListeners() {
    const self = this;
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.form.addEventListener('reset', (evt) => {
      this.setAttribute('data-result', false);
      this.initialRender(false);
      this.close();
      if (this.controller) this.controller.abort();
    });

    this.closeSearchBtns.forEach((btn) => {
      btn.addEventListener('click', function (evt) {
        self.close(true);
      });
    });

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));

    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        const term = this.getQuery();
        window.location.href = '/search?q=' + encodeURIComponent(term);
      });
    });

    if (this.isMobile) {
      this.searchIcon.addEventListener('focus', (evt) => {
        evt.preventDefault();
        this.open();
        this.input.focus();
      });
    }

    if (!this.isMobile) {
      window.onresize = debounce((evt) => {
        this.setModalPosition();
      });
    }
  }

  initialRender(openModel = true) {
    if (!this.defaultConfig) return;
    this.setAttribute('data-result', false);
    let trendingSearchesHtml = '',
      productsHtml = '';

    if (this.defaultConfig.defaultSuggestions.length)
      trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);

    if (this.defaultConfig.defaultProducts.length)
      productsHtml = this.buildProductGrid(
        this.defaultConfig.defaultProducts.slice(0, 10),
        this.defaultConfig.productTypes.slice(0, 10)
      );

    if (trendingSearchesHtml !== '') {
      this.trendingSearcheList.forEach((list) => {
        list
          .closest('.search-result-col-row')
          .classList.toggle('hidden', trendingSearchesHtml === '');
        list.innerHTML = trendingSearchesHtml;
      });
    }

    if (productsHtml !== '') this.predictiveSearchResults.innerHTML = productsHtml;
    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.classList.add('hidden');
    });
    this.form.removeAttribute('data-loading');
    if (openModel) this.open();
  }

  getSearchResults(searchTerm, event) {
    const queryKey = searchTerm.toLowerCase();
    this.setLiveRegionLoadingState();

    const cachedRes = this.cachedResults[queryKey];
    if (cachedRes) {
      if (cachedRes.totalItems === 0) this.renderEmptyResult(cachedRes, event);
      else this.renderSearchResults(cachedRes);
      return;
    }

    if (this.controller) this.controller.abort();

    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.form.setAttribute('data-loading', true);
    const maxSuggestion = 5;

    const menTags = ['gender_Men', 'GENDER_Men', 'Gender_Men', 'Gender_men', 'gender_men'];
    const womenTags = ['Gender_Women', 'gender_women', 'GENDER_Women', 'gender_Women'];
    let tagQuery = '';

    const searchTerms = queryKey ? queryKey.trim().toLowerCase().split(' ') : [];
    if (searchTerms.includes('women') || searchTerms.includes('woman'))
      tagQuery = '&restrictBy[snize_facet1]=' + womenTags.join('|');
    else if (searchTerms.includes('men') || searchTerms.includes('man'))
      tagQuery = '&restrictBy[snize_facet1]=' + menTags.join('|');
    else tagQuery = '';

    const BASE_URL =
      'https://searchserverapi.com/getwidgets?api_key=2K7F7z9Y9V&output=jsonp&items=true&maxResults=8&suggestions=true&suggestionsMaxResults=' +
      maxSuggestion +
      '&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5' +
      tagQuery; // restrictBy%5Bquantity%5D=1%7C&

    fetch(`${BASE_URL}&q=${encodeURIComponent(searchTerm)}`, { signal })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.json();
      })
      .then((res) => {
        this.cachedResults[queryKey] = res;
        if (res.totalItems === 0) this.renderEmptyResult(res, event);
        else this.renderSearchResults(res);
        this.controller = null;
      })
      .catch((error) => {
        // this.close();
        throw error;
      });
  }

  renderSearchResults(res) {
    if (!res.totalItems || res.totalItems === 0) return;

    this.removeAttribute('data-empty');
    const totalProducts = res.totalItems;
    const brandsHtml = this.buildBrandsList(res.categories);
    const suggestionsHtml = this.buildSuggestionList(res.suggestions);
    const trendingSearchesHtml = this.buildSuggestionList(this.defaultConfig.defaultSuggestions);
    const pagesHtml = this.buildPagesList(res.pages);
    const productsHtml = this.buildProductGrid(res.items.slice(0, 12));

    // Left :: List
    this.brandsList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', brandsHtml === '');
      list.innerHTML = brandsHtml;
    });

    this.suggestionList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', suggestionsHtml === '');
      list.innerHTML = suggestionsHtml;
    });

    this.trendingSearcheList.forEach((list) => {
      list
        .closest('.search-result-col-row')
        .classList.toggle('hidden', trendingSearchesHtml === '');
      list.innerHTML = trendingSearchesHtml;
    });

    this.pagesList.forEach((list) => {
      list.closest('.search-result-col-row').classList.toggle('hidden', pagesHtml === '');
      list.innerHTML = pagesHtml;
    });

    // Right :: Products
    this.predictiveSearchResults.innerHTML = productsHtml;

    this.setAttribute('results', true);
    this.setLiveRegionResults(totalProducts);

    this.predictiveSearchViewAllBtns.forEach((btn) => {
      btn.innerHTML = 'View All ' + totalProducts + ' Products';
      if (totalProducts > 8) btn.classList.remove('hidden');
      else btn.classList.add('hidden');
    });

    this.form.removeAttribute('data-loading');
    this.open();
  }
  renderEmptyResult(res, event) {
    if (event && event.type !== 'focus') {
      const searchTerm = this.getQuery();
      _theme.track.trackData({ event: 'zero_search_dropdown', search_term: searchTerm });
    }

    this.input.setAttribute('aria-invalid', true);
    this.setLiveRegionText('Sorry, nothing found for the search term ' + this.getQuery());
    this.setAttribute('data-empty', true);
    this.initialRender(false);
  }

  buildPagesList(pages) {
    if (!pages || pages.length === 0) return '';

    const pagesArr = pages.filter((page) => page.link.includes('/blogs/')).slice(0, 3);
    if (pagesArr.length === 0) return '';

    let mainHtml = '<ul role="list">';
    pagesArr.forEach(function (page) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="' +
        page.link +
        '">' +
        page.title +
        '</a></li>';
    });

    return mainHtml;
  }
  buildBrandsList(brands) {
    if (!brands || brands.length === 0) return '';

    let mainHtml = '<ul class="brand-list" role="list">';
    brands.slice(0, 1).forEach(function (brand) {
      if (brand.image_link != '') {
        var brand_content = `<span class="brand-img"><img src="${brand.image_link}" alt="${brand.title}"></span>`;
      } else {
        var brand_content = `<span class="brand-title">${brand.title}</span>`;
      }

      mainHtml +=
        '<li class="brand-item" role="listitem"><a href="' +
        brand.link +
        '">' +
        brand_content +
        '<span class="see-all">See all products</span></a></li>';
    });

    return mainHtml;
  }
  buildSuggestionList(suggestions) {
    if (!suggestions || suggestions.length === 0) return '';

    const internalPattern = /(_|\d{5,})/;
    const filtered = suggestions.filter(function (s) {
      return !internalPattern.test(s);
    });
    if (filtered.length === 0) return '';

    let mainHtml = '<ul role="list">';
    filtered.slice(0, 3).forEach(function (suggestion) {
      mainHtml +=
        '<li role="listitem"><a class="outline-inset" href="' +
        window.routes.search_url +
        '?q=' +
        encodeURI(suggestion) +
        '">' +
        suggestion +
        '</a></li>';
    });

    return mainHtml;
  }

  buildProductGrid(products, productTypes) {
    if (!products || products.length === 0) return '';
    const self = this;
    let mainHtml = '';

    products.forEach((product, productIndex) => {
      let product_html = _theme.product_html.productCardTemplate;

      const productHandle = self.extractHandle(product.link, 'product') || '';
      const variant = self.getFirstAvailableVariant(product);
      const productImages = self.buildProductImage(product, variant);
      const vid = variant ? variant.variant_id : product.shopify_variants?.[0]?.variant_id || '';

      // Map values to placeholders
      product_html = self.updateHtml(product_html, '[[Variant_Id]]', vid);
      product_html = self.updateHtml(product_html, '[[Product_Id]]', product.product_id);
      product_html = self.updateHtml(product_html, '[[Product_Handle]]', productHandle);
      product_html = self.updateHtml(product_html, '[[Product_URL]]', product.link);
      product_html = self.updateHtml(product_html, '[[Product_Title]]', product.title);
      product_html = self.updateHtml(product_html, '[[Product_Vendor]]', product.vendor || '');

      // Complex components
      product_html = self.updateHtml(
        product_html,
        '[[Product_Badges]]',
        self.buildProductBadge(product)
      );
      product_html = self.updateHtml(product_html, '[[Product_Image]]', productImages.image_1);
      product_html = self.updateHtml(
        product_html,
        '[[Product_Type]]',
        self.buildProductType(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Reviews]]',
        self.buildProductReviewSummary(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Price]]',
        self.buildProductPrice(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Actions]]',
        self.buildProductActionButton(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Notify_CTA]]',
        self.buildProductNotifyMeButton(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_Card_Class]]',
        self.updateGridClass(product)
      );
      product_html = self.updateHtml(
        product_html,
        '[[Product_JSON]]',
        self.buildProductJSON(product)
      );

      mainHtml += product_html;
    });

    return mainHtml;
  }
  buildProductBadge(product) {
    if (!product) return '';

    const timerSettings = window.countdownTimerSettings || {};
    const expressSettings = _theme.settings?.express_shipping || {};

    const isFlashExtensionActive = !!timerSettings.flashSaleExtensionActive;
    const isFlashTimerActive = this.isTimerActive(timerSettings);
    const isExpressEnabled = expressSettings.enabled === 'Enable';
    const expressThreshold = Number(expressSettings.quantity_threshold || 2);
    const deliveryDays = expressSettings.delivery_days || '2';
    const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1 || '';

    const variant = this.getFirstAvailableVariant(product);
    const vid = variant ? variant.variant_id : product.shopify_variants?.[0]?.variant_id || '';

    const productJson = {
      id: product.product_id,
      tags: (typeof product.tags === 'string'
        ? product.tags.split('[:ATTR:]')
        : product.tags || []
      ).map((t) => t.trim().toLowerCase()),
      variants:
        product.shopify_variants?.map((v) => ({
          id: v.variant_id,
          price: Number(v.price) * 100,
          compare_at_price: Number(v.list_price) * 100,
          available: v.available !== '0',
          title: v.title,
        })) || [],
    };

    const variantMetaJson =
      product.shopify_variants?.map((v) => ({
        id: v.variant_id,
        enable_flash_sale:
          v.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca,
        allow_express_shipping:
          v.search_variant_metafields_data?.variant_metafield_070071a13a8ea5aafeb0b99afa0c101f,
        brightperl_variant_inventory:
          v.search_variant_metafields_data?.variant_metafield_69f1d8722b9c470908fa53fe850945fb,
        is_offer_applicable:
          v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f,
      })) || [];

    return `
      <product-badges-component
        data-product-id="${product.product_id}"
        data-selected-variant-id="${vid}"
        data-is-offer-collection="false"
        data-max-badges="2"
        data-flash-sale-extension="${isFlashExtensionActive}"
        data-flash-sale-timer="${isFlashTimerActive}"
        data-express-shipping-enabled="${isExpressEnabled}"
        data-express-shipping-threshold="${expressThreshold}"
        data-delivery-days="${deliveryDays}"
        data-product-offer="${_theme.Helpers ? _theme.Helpers.escapeHtml(productOffer) : productOffer.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')}"
      >
        <script type="application/json" data-product-badges-json>
          ${JSON.stringify(productJson)}
        </script>
        <script type="application/json" data-product-badges-variant-meta-json>
          ${JSON.stringify(variantMetaJson)}
        </script>

        <div class="product-card__badge_root" data-product-badges-root></div>
      </product-badges-component>
    `;
  }
  buildProductImage(product, variant = null) {
    const primaryImage =
      variant?.image_link ||
      product.image_link ||
      'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';

    let secondaryImage = '';
    if (Array.isArray(product.shopify_images) && product.shopify_images.length > 1) {
      secondaryImage =
        product.shopify_images.find((image) => image && image !== primaryImage) || '';
    } else if (typeof product.shopify_images === 'string') {
      const imageList = product.shopify_images
        .replace(/\[|\]/g, '')
        .split(/,|\[:IMG:\]|\|/g)
        .map((item) => item.trim())
        .filter(Boolean);
      secondaryImage = imageList.find((image) => image && image !== primaryImage) || '';
    }

    if (
      !secondaryImage &&
      product.secondary_image_link &&
      product.secondary_image_link !== primaryImage
    ) {
      secondaryImage = product.secondary_image_link;
    }

    const image_1 = `
      <div class="product-card__image-stack${secondaryImage ? ' product-card__image-stack--has-secondary' : ''}">
        <img src="${primaryImage}" alt="${_theme.Helpers.escapeHtml(product.title)}" class="product-card__img product-card__image-primary" loading="lazy" width="300" height="300">
        ${secondaryImage ? `<img src="${secondaryImage}" alt="${_theme.Helpers.escapeHtml(product.title)} secondary" class="product-card__img product-card__image-secondary" loading="lazy" width="300" height="300" aria-hidden="true">` : ''}
      </div>
    `;

    return { image_1 };
  }
  buildProductType(product) {
    const productType =
      product.metafield_9e14d49086f4ac1134f463aa2738d80e || product.product_type || '';
    if (!productType) return '';

    return productType;
  }
  buildProductReviewSummary(product) {
    const metadata = product['metafield_68be2c8c872cca8e6b86ad08cbae727c'] || '';
    if (!metadata) return '';

    return `<div class="trustpilot-review-summary-wrapper">
              <trustpilot-review-summary
                data-show-popup="false"
                data-show-total="true"
                data-show-average="true"
                data-review-summary-metadata="${metadata.replace(/"/g, '&quot;')}"
                data-product-url="${product.link}"
                data-product-id="${product.product_id}"
              ></trustpilot-review-summary>
            </div>`;
  }
  buildProductPrice(product) {
    const prices = product.shopify_variants?.map((variant) => Number(variant.price)) || [];
    if (prices.length === 0) return '';

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    if (minPrice !== maxPrice) {
      const minFormatted = Shopify.formatMoney(minPrice * 100, window.money_format).replace(
        '.00',
        ''
      );
      const maxFormatted = Shopify.formatMoney(maxPrice * 100, window.money_format).replace(
        '.00',
        ''
      );
      return `
              <span class="visually-hidden">Price range</span>
              <span class="product-card__price-sale">${minFormatted} - ${maxFormatted}</span>
            `;
    } else {
      const variant = product.shopify_variants[0];
      const price = Shopify.formatMoney(variant.price * 100, window.money_format).replace(
        '.00',
        ''
      );
      const compareAt = variant.list_price
        ? Shopify.formatMoney(variant.list_price * 100, window.money_format).replace('.00', '')
        : '';

      return `<div class="price-left">
                <span class="visually-hidden">Sale price</span>
                <span class="product-card__price-sale">${price}</span>
                ${
                  Number(variant.list_price) > Number(variant.price)
                    ? `
                  <span class="visually-hidden">Original price</span>
                  <span class="product-card__price-original">${compareAt}</span>
                `
                    : ''
                }
              </div>`;
    }
  }
  buildProductActionButton(product) {
    return '';
  }
  buildProductNotifyMeButton(product) {
    let html = '';
    const isAvailable = this.isProductAvailable(product);

    if (!isAvailable) {
      let notifyHTML = _theme.product_html.notify_me;
      notifyHTML = this.updateHtml(notifyHTML, '[[notify_me_product_id]]', product.product_id);
      html = notifyHTML;
    }

    return html;
  }
  buildProductJSON(product) {
    if (!product) return '';

    try {
      let html = '<script type="application/json" data-product-json>[[pjson]]</script>';
      let variantTitle = product.title;

      if (product.shopify_variants?.[0]?.options) {
        variantTitle = product.shopify_variants[0].options.Size || variantTitle;
      }

      const variantId = product.shopify_variants?.[0]?.variant_id || product.shopify_variants?.[0]?.id || product.variants?.[0]?.id || '';
      const pjson = {
        id: product.product_id,
        product_id: product.product_id,
        variant_id: variantId,
        title: product.title,
        product_title: product.title,
        vendor: product.vendor,
        type: product.product_type,
        product_type: product.product_type,
        discount: product.discount,
        collection_handle: '',
        collection_title: '',
        collection_id: '',
        item_list_id: '',
        variant_title: variantTitle,
        price: Number(product.price),
        compareAtPrice: Number(product.list_price),
        compare_at_price: Number(product.list_price),
      };

      html = html.replace('[[pjson]]', JSON.stringify(pjson));
      return html;
    } catch (error) {
      return '';
    }
  }

  updateGridClass(product) {
    let html = '';
    const isAvailable = this.isProductAvailable(product);
    html = isAvailable ? 'available' : 'sold_out';
    return html;
  }
  updateHtml(html, str, data) {
    let newhtml = html;
    if (newhtml.indexOf(str) > -1) {
      newhtml = newhtml.replace(str, data);
      return this.updateHtml(newhtml, str, data);
    } else {
      return newhtml;
    }
  }

  isProductAvailable(product) {
    const isAvailable = product.shopify_variants?.some(function (variant) {
      return variant.available !== '0';
    });

    return isAvailable ? true : false;
  }
  isTimerActive(timerSettings) {
    // Only consider timer active if enabled is true or 'True', everything else is false
    const enabled = timerSettings.enabled;
    if (enabled !== true && enabled !== 'True') {
      return false;
    }

    // Check if required date/time fields are present
    if (
      !timerSettings.startDate ||
      !timerSettings.startTime ||
      !timerSettings.endDate ||
      !timerSettings.endTime
    ) {
      return false;
    }

    const startDateTime = _theme.Helpers.parseESTDate(
      timerSettings.startDate,
      timerSettings.startTime
    ).getTime();

    const endDateTime = _theme.Helpers.parseESTDate(
      timerSettings.endDate,
      timerSettings.endTime
    ).getTime();

    const currentTime = _theme.Helpers.getCurrentESTTime();

    const isActive = currentTime >= startDateTime && currentTime <= endDateTime;

    return isActive;
  }
  getFirstAvailableVariant(product) {
    if (!product.shopify_variants) return null;

    const timerSettings = window.countdownTimerSettings || {};
    const isFlashActive =
      this.isTimerActive(timerSettings) && timerSettings.flashSaleExtensionActive === true;

    const flashVariants = product.shopify_variants.filter(
      (variant) =>
        variant.search_variant_metafields_data
          ?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
        variant.available !== '0'
    );

    if (isFlashActive && flashVariants.length > 0) {
      return flashVariants[0];
    }

    return (
      product.shopify_variants.find((variant) => variant.available !== '0') ||
      product.shopify_variants[0]
    );
  }
  getResultsMaxHeight() {
    const announcementBottom = document
      .getElementById('shopify-section-announcement-bar')
      .getBoundingClientRect().bottom;
    const modelTopPos = document
      .getElementById('shopify-section-header-new')
      .getBoundingClientRect().bottom;
    this.resultsMaxHeight = window.innerHeight - modelTopPos;
    return {
      modelMaxHeight: this.resultsMaxHeight,
      modelTopPos: modelTopPos,
      announcementBottom: announcementBottom,
    };
  }

  getQuery() {
    return this.input.value.trim();
  }
  handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }
  extractHandle(value, type) {
    if (!value) return '';

    const cleaned = value.split('?')[0].split('#')[0].replace(/\/$/, '');
    if (type === 'product') {
      const match = cleaned.match(/\/products\/([^\/]+)/);
      return match ? match[1] : '';
    }

    const match = cleaned.match(/\/collections\/([^\/]+)/);
    return match ? match[1] : cleaned;
  }

  open() {
    const self = this;
    document.body.classList.add('search-active', 'overflow-hidden');
    this.formResetBtn.setAttribute('tabindex', 0);
    this.setAttribute('open', true);
    // this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    if (!this.isMobile) this.setModalPosition();
    _theme.focusTrap(
      $(this),
      () => {
        this.close(true);
      },
      null,
      true
    );
  }
  close(clearSearchTerm) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.removeAttribute('open');
    this.input.setAttribute('aria-activedescendant', '');
    // this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
    document.body.classList.remove('search-active', 'overflow-hidden');
    this.form.removeAttribute('data-loading');
    this.formResetBtn.setAttribute('tabindex', -1);
    this.isOpen = false;
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
  selectOption() {
    const selectedProduct = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );

    if (selectedProduct) selectedProduct.click();
  }

  onChange(event) {
    this.input.removeAttribute('aria-invalid');
    this.removeAttribute('data-empty');
    const searchTerm = this.getQuery();
    this.noResultTextNodes.forEach((elem) => (elem.innerHTML = '\"' + searchTerm + '\"'));
    this.form.querySelector('input[name="q"]').value = searchTerm;
    if (!searchTerm.length) {
      this.setAttribute('data-result', false);
      this.initialRender();
      this.setLiveRegionText('found top trending searches & prodducts');
      return;
    }

    this.setAttribute('data-result', true);
    this.getSearchResults(searchTerm, event);
  }
  onFocus(event) {
    this.open();
    const searchTerm = this.getQuery();
    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm, event);
    }
  }
  onFocusOut(evt) {
    const isInsideModal = this.contains(evt.target);
    const isRelatedTargetInsideModal = evt.relatedTarget ? this.contains(evt.relatedTarget) : true;

    setTimeout(() => {
      if (!isInsideModal || !isRelatedTargetInsideModal) this.close();
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.form.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }
  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
  setLiveRegionResults(totalProducts) {
    const searchTerm = this.getQuery();
    this.removeAttribute('loading');
    this.setLiveRegionText(totalProducts + ' products found for the search term ' + searchTerm);
  }
}

window.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 1025) {
    const hsw = document.querySelector('.site-header .head-search');
    const hs = document.querySelector('header-search');
    hsw && hs && hsw.append(hs);
  }
  customElements.define('header-search', HeaderSearch);
});

// const initHeaderSearch = () => {
//   if (window.innerWidth < 1025) {
//     const hsw = document.querySelector('.site-header .head-search');
//     const hs = document.querySelector('header-search');

//     if (hsw && hs && !hsw.contains(hs)) {
//       hsw.append(hs);
//     }
//   }

//   if (!customElements.get('header-search')) {
//     customElements.define('header-search', HeaderSearch);
//   }
// };

// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', initHeaderSearch, { once: true });
// } else {
//   initHeaderSearch();
// }
